const provincesCanada = [
    "Alberta",
    "Colombie-Britannique",
    "Manitoba",
    "Nouveau-Brunswick",
    "Terre-Neuve-et-Labrador",
    "Nouvelle-Écosse",
    "Ontario",
    "Île-du-Prince-Édouard",
    "Québec",
    "Saskatchewan"
];

export default provincesCanada;
